import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    GetsubBlockWeightmentDetailsReportData,
    GetAllOperationEntityByGroupID,
    GetFieldsByCollectionPointID
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function GetsubBlockWeightmentDetailsReportData(data) {
    const model = {
        groupID: data.groupID,
        estateID: data.estateID,
        divisionID: data.divisionID,
        fieldID: data.fieldID,
        searchDate: data.searchDate,
    };
    const response = await CommonPost('/api/SubBlockWeightmentDetailsReport/GetSubBlockWeightmentDetails', null, model);
    return response.data;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetEveryDivisionsFromOperationEntitiyID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return divisionArray;
}
async function GetFieldsByCollectionPointID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/Field/GetOutsourceFieldsByCollectionPointID', 'id=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["fieldID"]] = item[1]["costCenterName"]
        }
    }
    return divisionArray;
}